/* eslint-disable sonarjs/cognitive-complexity */
import React, { useEffect, useMemo, useState } from 'react';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Col, Row } from 'antd';
import { isEmpty } from 'lodash';
import { Form } from 'formik-antd';
import { useDispatch } from 'react-redux';
import { Box, FormInput, CustomInput, Button } from 'atoms';
import { Debug } from '../Debug';
import { updateClient } from 'store/clientSlice';
import { ACL, EditModeBtn, ImageView } from 'components/common';
// import { useQuery } from 'hooks';
import FilesUploadS3 from 'components/common/FilesUploadS3';
import { pdfimgfiletypetoShow, pdfimgformates } from 'utils';
import { CancelButton } from 'utils/commonStyled';

const FormSchema = Yup.object({
	acc_number: Yup.string()
		.required()
		.min(6)
		.max(24)
		.label('Account Number')
		.matches(/^[0-9]*$/, 'Please enter valid Account Number'),
	ifsc_code: Yup.string()
		.required()
		.min(11)
		.max(11)
		.label('IFSC Code')
		.matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Please enter valid IFSC ode'),
	bank_name: Yup.string()
		.required()
		.min(4)
		.max(30)
		.label('Bank Name')
		.matches(/^[a-zA-Z ]*$/, 'Please enter valid Bank Name'),
	bank_city: Yup.string()
		.required()
		.label('Bank City')
		.matches(/^[a-zA-Z ]*$/, 'Please enter valid City'),
	bank_branch: Yup.string()
		.required()
		.min(5)
		.max(32)
		.label('Bank Branch')
		.matches(/^[a-zA-Z0-9 -.,&/()]*$/, 'Please enter valid Branch'),
});

export default function BankInfoForm({
	isEditMode = false,
	formData = {},
	otherFormsData,
	activeTab,
}) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	// const [query] = useQuery();
	const [filesList, setFilesList] = useState([]);
	const [editMode, setEditMode] = useState(false);
	const [isCreate, setIsCreate] = useState(false);

	console.log(activeTab);

	const initialValues = useMemo(
		() => ({
			acc_number: formData?.acc_number || undefined,
			ifsc_code: formData?.ifsc_code || undefined,
			bank_name: formData?.bank_name || undefined,
			bank_city: formData?.bank_city || undefined,
			bank_branch: formData?.bank_branch || undefined,
		}),
		[formData]
	);

	const handleSubmit = (values, { setErrors, setSubmitting }) => {
		const payload = {
			...otherFormsData,
			banking_info: {
				...values,
				bank_doc: !isEmpty(filesList) ? filesList : formData?.bank_doc,
			},
		};

		if (isEditMode) {
			payload.update_type = 'client';
		} else {
			payload.create_type = 'client';
		}

		dispatch(
			updateClient({
				req_data: payload,
				info: 'bank_info',
				setErrors,
				isEditMode,
			})
		)
			.then((res) => {
				window.location = `${window.origin}/clients/${res.data.id}?tab=3`;
				setSubmitting(false);
			})
			.catch(() => {
				setSubmitting(false);
			});
	};

	function handleFileUpload(files) {
		console.log('handleFileUpload', files);
		setFilesList(files);
	}
	function handleEdit() {
		setEditMode(!editMode);
	}

	useEffect(() => {
		setIsCreate(location.pathname.split('/').pop() === 'addsection');
	});

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
			enableReinitialize
		>
			{() => (
				<Box>
					<ACL action="update" module="client">
						{isEditMode && <EditModeBtn handleEdit={handleEdit} />}
					</ACL>
					<Form className={editMode === false && !isCreate ? 'disabled-div' : ''}>
						<Box padding="1.5rem 2rem" background="#fff">
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="acc_number" label="Account Number *">
										<CustomInput name="acc_number" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="ifsc_code" label="IFSC Code *">
										<CustomInput name="ifsc_code" maxLength={11} isCaps />
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="bank_name" label="Bank Name *">
										<CustomInput name="bank_name" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="bank_city" label="Bank City *">
										<CustomInput name="bank_city" />
									</FormInput>
								</Col>
							</Row>

							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="bank_branch" label="Bank Branch *">
										<CustomInput name="bank_branch" />
									</FormInput>
								</Col>
							</Row>
						</Box>
						<Box border="1px solid #ccc" padding="34px">
							<FilesUploadS3
								entity="client"
								successCallBack={handleFileUpload}
								name="Bank document"
								size={5120000}
								fileformates={pdfimgformates}
								filetypetoShow={pdfimgfiletypetoShow}
							/>
							<Box backgroundColor="#fff" textAlign="right" padding="1.5rem"></Box>
							{filesList && (
								<ImageView
									entity="client"
									files={formData?.bank_doc}
									name="Bank Document"
								/>
							)}
						</Box>
						<Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem">
							<CancelButton onClick={() => navigate('/client-list')} type="button">
								Cancel
							</CancelButton>
							<Button borderRadius="4px" backgroundColor="#18405d" type="submit">
								{isEditMode ? 'Update' : 'Submit'}
							</Button>
						</Box>
						<Debug />
					</Form>
				</Box>
			)}
		</Formik>
	);
}

BankInfoForm.propTypes = {
	isEditMode: PropTypes.bool,
	formData: PropTypes.object,
	otherFormsData: PropTypes.object,
	activeTab: PropTypes.any,
};
